import { generatePdpUrl } from './vehicle';
export const formattedDate = (timestamp) => {
    if (!timestamp)
        return '';
    try {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        return `${year}-${month}-${day}`;
    }
    catch (_a) {
        return '';
    }
};
export const replacePricesInUrl = (url, typedPrices) => {
    if (!typedPrices || typedPrices.length === 0)
        return url;
    let result = url;
    typedPrices.forEach((price) => {
        const pattern = `{{sc_${price.type}}}`;
        const replaceValue = `${price.amount}`;
        result = result.replace(pattern, replaceValue);
    });
    return result;
};
export function formatUrl(pattern, vehicle) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let url = pattern;
    url = url.replace('{{sc_vehicle_id}}', vehicle.id);
    const seoUrl = generatePdpUrl(vehicle.modelYear, ((_a = vehicle.model) === null || _a === void 0 ? void 0 : _a.description) || ((_b = vehicle.symbolicCarline) === null || _b === void 0 ? void 0 : _b.description), vehicle.id);
    url = url.replace('{{sc_vehicle_url}}', seoUrl);
    url = url.replace('{{sc_car_id}}', vehicle.carId);
    url = url.replace('{{sc_audicode}}', vehicle.audiCode);
    url = url.replace('{{sc_dealer_id}}', (_c = vehicle.dealer) === null || _c === void 0 ? void 0 : _c.id);
    url = url.replace('{{sc_dealer_name}}', (_d = vehicle.dealer) === null || _d === void 0 ? void 0 : _d.name);
    url = url.replace('{{sc_raw_dealer_id}}', vehicle.rawDealerId);
    url = url.replace('{{sc_commission_number}}', vehicle.commissionNumber);
    url = url.replace('{{sc_market_reference}}', `${vehicle.marketReference}`);
    url = url.replace('{{sc_model_code}}', (_e = vehicle.modelCode) === null || _e === void 0 ? void 0 : _e.code);
    url = url.replace('{{sc_carline}}', (_f = vehicle.symbolicCarline) === null || _f === void 0 ? void 0 : _f.code);
    url = url.replace('{{sc_carline_description}}', encodeURIComponent((_g = vehicle.symbolicCarline) === null || _g === void 0 ? void 0 : _g.description));
    url = url.replace('{{sc_entry_url}}', encodeURIComponent(vehicle.entryUrl));
    url = url.replace('{{sc_model_year}}', `${vehicle.modelYear}`);
    url = url.replace('{{sc_vin}}', `${vehicle.vin}`);
    url = url.replace('{{sc_stock_keeping_unit}}', vehicle.stockkeepingunit);
    if (vehicle.financeLoan) {
        url = url.replace('{{sc_loan_type}}', `${(_h = vehicle.financeLoan) === null || _h === void 0 ? void 0 : _h.info}`);
    }
    if (vehicle.used) {
        url = url.replace('{{sc_mileage}}', `${(_j = vehicle.used) === null || _j === void 0 ? void 0 : _j.mileage}`);
        if ((_k = vehicle.used) === null || _k === void 0 ? void 0 : _k.initialRegistrationDate) {
            const { initialRegistrationDate } = vehicle.used;
            url = url.replace('{{sc_initialregistration_month}}', String(new Date(initialRegistrationDate).getMonth() + 1));
            url = url.replace('{{sc_initialregistration_year}}', String(new Date(initialRegistrationDate).getFullYear()));
            const formatted = formattedDate(initialRegistrationDate);
            url = url.replace('{{sc_initial_registration_date}}', formatted);
        }
    }
    if (vehicle === null || vehicle === void 0 ? void 0 : vehicle.preused) {
        url = url.replace('{{sc_preused}}', vehicle === null || vehicle === void 0 ? void 0 : vehicle.preused);
    }
    const retailPrice = (_l = vehicle.typedPrices) === null || _l === void 0 ? void 0 : _l.find((price) => price.type === 'retail');
    if (retailPrice) {
        url = url.replace('{{sc_price}}', `${retailPrice.amount}`);
    }
    const regularPrice = (_m = vehicle.typedPrices) === null || _m === void 0 ? void 0 : _m.find((price) => price.type === 'regular');
    if (regularPrice) {
        url = url.replace('{{sc_list_price}}', `${regularPrice.amount}`);
    }
    url = replacePricesInUrl(url, vehicle.typedPrices);
    if (typeof window !== 'undefined') {
        try {
            const lsUrlOrigin = JSON.parse(window.localStorage.getItem('url_origin'));
            const lsUrlSearch = JSON.parse(window.localStorage.getItem('url_search'));
            url = url.replace('{{sc_url_origin}}', (lsUrlOrigin === null || lsUrlOrigin === void 0 ? void 0 : lsUrlOrigin.value) || '');
            url = url.replace('{{sc_url_search}}', (lsUrlSearch === null || lsUrlSearch === void 0 ? void 0 : lsUrlSearch.value) || '');
            url = url.replace('{{sc_location}}', window.location.href);
        }
        catch (err) {
            console.log('Cannot parse pattern from localStorage', err);
        }
    }
    return url;
}
export const replaceVehicleTitleAndSubtitle = (text, vehicle) => {
    var _a, _b;
    return (text || '')
        .replace(/\${/g, '{')
        .replace(/{title}/g, ((_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.mbvHandbook) === null || _a === void 0 ? void 0 : _a.description) || '')
        .replace(/{subtitle}/g, ((_b = vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelCode) === null || _b === void 0 ? void 0 : _b.description) || '');
};
